/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { V3RTBOrderLine } from '../models/V3RTBOrderLine';
import { HttpFile } from '../http/http';

/**
* The event emitted when RTB deploy configuration is created
*/
export class V1OrderLineDestinationRTBCreated {
    'id'?: string;
    'advertiserId'?: string;
    'rtbOrderLine'?: V3RTBOrderLine;
    'segmentIds'?: Array<string>;
    'creativeIds'?: Array<string>;
    'status'?: V1OrderLineStatus;
    'userId'?: string;
    'orgId'?: string;
    'timestamp'?: Date;
    'requestId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "advertiserId",
            "baseName": "advertiser_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "rtbOrderLine",
            "baseName": "rtb_order_line",
            "type": "V3RTBOrderLine",
            "format": ""
        },
        {
            "name": "segmentIds",
            "baseName": "segment_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "creativeIds",
            "baseName": "creative_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V1OrderLineStatus",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineDestinationRTBCreated.attributeTypeMap;
    }

    public constructor() {
    }
}

